// extracted by mini-css-extract-plugin
export var content = "styles-module--content--72918";
export var title = "styles-module--title--dc7f2";
export var userReviews = "styles-module--userReviews--f1a80";